module.exports = __webpack_public_path__ + "static/img/1692694679029.45d20778.jpg";